import { useAdminStore } from "./../store/adminStore.js";
function dragStart(event, itemId) {
  if (event.dataTransfer) {
    event.dataTransfer.dropEffect = "move";
    event.dataTransfer.effectAllowed = "move";
    event.dataTransfer.setData("elementId", itemId.toString());
    const ghostEle = document.getElementById(
      event.dataTransfer.getData("elementId")
    );
    if (ghostEle) {
      event.dataTransfer.setDragImage(ghostEle, 0, 0);
    }
    const adminStore = useAdminStore();
    adminStore.isDragging = true;
  }
}
function dragEnd() {
  const adminStore = useAdminStore();
  adminStore.isDragging = false;
}
export { dragStart, dragEnd };
